import mentoApi from './mentoApi';

export const getSubscriptionDetails = async (subId: string) => {
  const result = await mentoApi.get(
    `/user_payments/detailed_subscription/${subId}`,
  );
  return result.data;
};
